import React from 'react';


const IconLeftMenuUnsorded: React.FC = () => (
    <svg className="svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
            d="M12.6667 2.6665H3.33333V3.6665H12.6667V2.6665ZM2.66667 4.33317H13.3333V5.33317H2.66667V4.33317ZM12.6667 7.33317H3.33333V12.6665H12.6667V7.33317ZM3.33333 5.99984H2V7.33317V12.6665V13.9998H3.33333H12.6667H14V12.6665V7.33317V5.99984H12.6667H3.33333Z"
            fill="#4D4E65" />
    </svg>


);

export default IconLeftMenuUnsorded;